import api from 'Plugins/api'
import VisaOrder from '../entities/visa-order'

/**
 * 签证订单用例类
 */
class VisaOrderInteractor {
  /**
   * 获取签证正常订单详请
   */
  static async getDetailById(orderId) {
    try {
      const { data = {} } = await api['VisaOrder/VisaOrderDetail']({ orderId })
      
      return {
        data: new VisaOrder(data)
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 补填寄送信息
   * @param {order: VisaOrder} order 签证订单
   */
  static async fillSendInfo(order) {
    try {
      if (!order.expressCompanyName) throw '请填写快递公司'
      if (!order.expressNumber) throw '请填写快递单号'
      
      order.expressCompany = order.expressCompanyName
      const { data = {} } = await api['VisaOrder/FillSendInfo'](order)
      
      return {
        data
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 获取签证办理进度
   * @param {orderId: String} order 签证订单id
   */
  static async getProgress(orderId) {
    try {
      const { data = [] } = await api['VisaOrder/GetProgress']({ orderId })
      
      return {
        data
      }
    } catch (error) {
      throw error
    }
  }

}

export default VisaOrderInteractor